import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

import { RouterModule } from '@angular/router';
import {StatTypeUserEnum} from "../../types/StatTypeUser.enum";

@Component({
  selector: 'app-statistic-menu',
  templateUrl: './statistic-menu.component.html',
  styleUrls: ['./statistic-menu.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterModule]
})
export class StatisticMenuComponent {
  @Input() typeUser: StatTypeUserEnum = StatTypeUserEnum.SPEAKER;
  type = StatTypeUserEnum;

}
